import React from 'react'
import { Flex, HStack, Box, Heading, Text, useColorMode, IconButton, Icon } from '@chakra-ui/react'
import { colorKeys, getColor } from '../../config/constants/appColors'
import APP_ICONS from '../../config/constants/icons'
import AvatarNamesStack from '../BasicUI/DataBoxes/AvatarNamesStack'
import DeletePopover from '../BasicUI/DeletePopover'
import { formatDateTimeFromNow } from '../../config/helpers/dateHelper'

const NotesCard = ({ item, onDelete }) => {
  const { colorMode } = useColorMode()

  return (
    <Flex p="1" w="full" justify={"space-between"} _hover={{ bg: getColor(colorKeys.tableRowHoverBackground, colorMode) }} role='group'>
      <HStack spacing={3}>
        <Flex align="center" h="70px" w="80px" bg={getColor(colorKeys.lightestGray, colorMode)}>
          <Icon h="50px" w="80px" as={APP_ICONS.DOCUMENT} objectFit={"cover"} />
        </Flex>
        <Box>
          <Heading mb="2px" fontSize={"15px"}>{item?.name}</Heading>
          <AvatarNamesStack data={item?.teachers} />
          <Text mt={"5px"} fontSize="12px">Updated {item.updatedBy?.dateTime ? formatDateTimeFromNow(item.updatedBy?.dateTime) : formatDateTimeFromNow(item.createdBy?.dateTime)}</Text>
        </Box>
      </HStack>

      <HStack mr="5" display={"none"} _groupHover={{ display: "flex" }}>
        <IconButton size="sm" icon={<Icon as={APP_ICONS.EDIT} />} />
        <DeletePopover onConfirm={() => onDelete(item.id)} confirmation="Are you sure you want to delete these notes?">
          <IconButton size="sm" icon={<Icon as={APP_ICONS.BIN} />} />
        </DeletePopover>
      </HStack>
    </Flex>
  )
}

export default NotesCard